import { css } from "@emotion/css";

export const chatDialogCSS = css`
  position: fixed;
  top: 60px;
  right: 0;
  margin: 0;
  width: 500px;
  max-width: 600px;
  min-width: 350px;
  height: calc(100vh - 100px);
  z-index: 8000;
  min-height: 400px;
`;

export const resizeHandleCSS = css`
  position: absolute;
  right: 8px;
  bottom: 8px;
  width: 24px;
  height: 24px;
  cursor: nwse-resize;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
